export default __webpack_public_path__ + "07e1a1690ea897bc62b511231c64037e.png";